/**
 * IA-R10 — Evidence Graph + Evidence Timeline (Soft façade).
 * Full graph backend not live — honest Soft links only.
 */
import { escapeHtml } from "./dom.js";

/**
 * @param {{
 *   eventId?: string,
 *   deviceId?: string,
 *   snapshotId?: string,
 *   incidentId?: string,
 *   compact?: boolean,
 * }} [opts]
 */
export function evidenceGraphSoftHtml(opts = {}) {
  const eventId = String(opts.eventId || "").trim();
  const deviceId = String(opts.deviceId || "").trim();
  const snapshotId = String(opts.snapshotId || "").trim();
  const incidentId = String(opts.incidentId || "").trim();
  const nodes = [
    { k: "Alarm", v: eventId || "—" },
    { k: "Device", v: deviceId || "—" },
    { k: "Snapshot", v: snapshotId || "linked Soft" },
    { k: "AI plan", v: incidentId || "—" },
    { k: "Person", v: "Assign Soft · App GPS on Home map" },
  ];
  const nodeHtml = nodes
    .map((n) => `<li class="croc-evg__node"><span class="croc-evg__k">${escapeHtml(n.k)}</span><span class="croc-evg__v">${escapeHtml(n.v)}</span></li>`)
    .join("");
  return `
  <section class="croc-evg glass-panel glass-panel--inset" data-evidence-graph="1" aria-label="Evidence Graph Soft">
    <p class="croc-evg__eyebrow">Evidence Graph · Soft</p>
    <p class="muted croc-evg__lede">Links you can open now — full graph backend not live.</p>
    <ul class="croc-evg__nodes">${nodeHtml}</ul>
    <div class="row" style="gap:8px;flex-wrap:wrap;margin-top:10px">
      <button type="button" class="btn sm btn-tap" data-cc-go="snapshots"${eventId ? ` data-cc-id="${escapeHtml(eventId)}"` : ""}>Photos</button>
      <button type="button" class="btn sm secondary btn-tap" data-cc-go="account/cameras">Cameras</button>
      <button type="button" class="btn sm ghost btn-tap" data-cc-go="incidents"${eventId ? ` data-cc-id="${escapeHtml(eventId)}"` : ""}>Case</button>
      ${incidentId
        ? `<button type="button" class="btn sm ghost btn-tap" data-ai-home-more-evidence="${escapeHtml(incidentId)}">Request more evidence</button>`
        : ""}
    </div>
  </section>`;
}

/**
 * @param {{ steps?: { k: string, v: string }[], eventId?: string }} [opts]
 */
export function evidenceTimelineSoftHtml(opts = {}) {
  const steps = Array.isArray(opts.steps) && opts.steps.length
    ? opts.steps
    : [
        { k: "Notify", v: "Alerts fired first" },
        { k: "Observe", v: "Map · scene Soft" },
        { k: "Assess", v: "Rules + server why Soft|Live" },
        { k: "Decide", v: "Continue or Hold" },
        { k: "Evidence", v: "Photos · Frame Soft" },
        { k: "Proof", v: "Close on case" },
      ];
  const eventId = String(opts.eventId || "").trim();
  const rows = steps
    .map((s) => `<li class="croc-evt__step"><strong>${escapeHtml(s.k)}</strong><span class="muted">${escapeHtml(s.v)}</span></li>`)
    .join("");
  return `
  <section class="croc-evt" data-evidence-timeline="1" aria-label="Evidence Timeline Soft">
    <p class="croc-evt__eyebrow">Evidence Timeline · Soft</p>
    <ol class="croc-evt__list">${rows}</ol>
    ${eventId
      ? `<button type="button" class="btn sm ghost btn-tap" data-cc-go="incidents" data-cc-id="${escapeHtml(eventId)}">Open case timeline</button>`
      : `<button type="button" class="btn sm ghost btn-tap" data-cc-go="incidents">Open cases</button>`}
  </section>`;
}
